// extracted by mini-css-extract-plugin
module.exports = {"message":"success-popup_message__1zOI1","icon":"success-popup_icon__3H64-","heading":"success-popup_heading__3aOqL"};